// extracted by mini-css-extract-plugin
export default {"content":"QrCode_content__CoA6E","contentValue":"QrCode_contentValue__1vzPJ"};